import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useTableStore } from "~/stores/use-table-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import TableContext from "./table-context";

export default function TableContextDialog() {
  const { tableContextOpen, setTableContextOpen } = useTableStore();
  const { t } = useTranslation("common");
  return (
    <Dialog
      onOpenChange={(open) => {
        if (open === false) {
          setTableContextOpen(undefined);
        }
      }}
      open={!!tableContextOpen}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("table_context_menu_title", {
              reference: tableContextOpen?.reference,
            })}
          </DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4 flex flex-col gap-4">
          {tableContextOpen && (
            <TableContext
              table={tableContextOpen}
              onClose={() => setTableContextOpen(undefined)}
            />
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
